export default __webpack_public_path__ + "static/media/face3.a4a405a8.svg";